import React from 'react'
import { useState, useEffect } from 'react';
import { VideosPreview } from './VideosPreview';
import "./AllVideosView.css";


function AllVideosView() {
  const [videosList, setVideosList] = useState(null);
  const [loading, setLoading] = useState(true);
  console.log('hi from AllVideosView')

  useEffect(() => {
    
  //get videos data from backend
      fetch("/Videos/GetVideos", {
          method: "GET",
          headers: {
              "Content-Type": "application/json"
          }
      })
          .then(res => {
              if (!res.ok) {
                  throw new Error("Ответ не Ok");
              }
              return res.json();
          })
          .then(data => {
            console.log(data);
            setVideosList(data.slice(0, 3));
            setLoading(false);
          })
          .catch(error => {
            console.error(error);
            setLoading(false);
          });
     }, []); // Empty dependency array means this effect runs once when the component mounts

    console.log(videosList);

  if (loading) {
      return <div className="loading show"/>
    }  

  return (
    <div id="allVideosView">
        {
          videosList && videosList.map((video, index) => 
          (<VideosPreview video={video} index={index} />))
        }
    </div>
  );
};

export { AllVideosView }

